module.exports = __webpack_public_path__ + "media/images/favicons/android-icon-72x72-8ea76c8964b240cb5cd417415215ea00.png";